import React from "react";

const About = () => {
  return (
    <div style={{marginTop:'100px', marginLeft:'15px', width:'60%', textAlign:'justify'}}>
      <h1>About Stack Overflow</h1>
      <p style={{backgroundColor:'#eeeeee' ,padding:'10px', borderRadius:'3px'}}>
        Stack Overflow is a question-and-answer website for computer
        programmers. It is the flagship site of the Stack Exchange Network. It
        was created in 2008 by Jeff Atwood and Joel Spolsky. It features
        questions and answers on certain computer programming topics.
      </p>
    </div>
  );
};

export default About;
